import { render, staticRenderFns } from "./GoodDetail.vue?vue&type=template&id=0eea9a4a"
import script from "./GoodDetail.vue?vue&type=script&lang=js"
export * from "./GoodDetail.vue?vue&type=script&lang=js"
import style0 from "./GoodDetail.vue?vue&type=style&index=0&id=0eea9a4a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports